//**************************************************************
import {  Component, 
          ViewChild, 
          OnInit,
          ChangeDetectorRef, 
          AfterViewInit,
          ElementRef  }                                 from '@angular/core';
//**************************************************************
// Router
import { Router, ActivatedRoute }                       from '@angular/router';

import { Observable, Subscription }                     from 'rxjs';
//**************************************************************
// Environment - Global Variables
import { environment }                                  from '../environments/environment.prod'
//**************************************************************
// Firestore 
import { firestorecontrol }                             from '../app/appfirestore/app.firestore'
//**************************************************************
// List Structures
import { menuitem, liststructures }                     from '../app/classinjection/app.liststructures';

import { faqdetail }                                    from '../app/appfirestore/app.fields';
//**************************************************************
import {  DxListComponent,
          DxAccordionComponent,
          DxTextAreaComponent,
          DxToolbarComponent }    from 'devextreme-angular';
//**************************************************************
// Login Dialogue Box
import { ComloginComponent }                            from '../app/components/comlogin/comlogin.component';
import { RegistrationLoginModal }                       from '../app/components/comlogin/comloginclass';
import { MatDialog }                                    from '@angular/material/dialog';
//**************************************************************
// Font Awesome Icons
import { faCoffee }                                     from '@fortawesome/free-solid-svg-icons';
//**************************************************************
@Component
  (
    {
      selector: 'app-root',
      templateUrl: './app.component.html',
      styleUrls:  ['./app.component.scss'],
      providers:  [
                    liststructures
                  ],
      preserveWhitespaces: true,
    }
  )
//**************************************************************
export class AppComponent implements OnInit
  {
    faCoffee = faCoffee;

    title = 'GetOrganised';

  // @ViewChild(DxListComponent, { static: false }) list: DxListComponent;
    @ViewChild('toolbaritem') toolbar: DxToolbarComponent ;
    @ViewChild('listparticipant') list: DxListComponent ;
    @ViewChild('accordion') faqaccordion: DxAccordionComponent;

    @ViewChild('faqnote') faqnote: DxTextAreaComponent;
    @ViewChild('faqnoteElement') textAreaElement: ElementRef;



    faqproperty:             Subscription;
    faqprofile:              faqdetail[];

    // EventId
    selectEventId: string = 'TBC';
  
    // Screen width & Height
    windowWidth: any;
    windowHeight: any;
    widowbottomoffset: number = 40;
    windowHeightFAQ: any;

    appformname: string;

  
    formtitle: string = '';
    toolbarContentVisible: boolean = true;

   // toolbarContent = [
   //                     {
   //                       widget: 'dxButton',
    //                      location: 'before',
   //                       locateInmenu: 'always',
   //                       options:  {
   //                                   icon: 'menu',
   //                                   onClick: () => this.isDrawerOpen = !this.isDrawerOpen
   //                                 },
   //                     },
                        
                        
   //                     {
   //                       widget: 'dxTextBox',
   //                       location: 'center',
   //                       locateInmenu: 'always',
   //                       visible: true,
   //                       options:  {
   //                                   value: 'dddddddddddd',
   //                                   width: '100%',
   //                                   disabled: true,
                                      
   //                                 },
                        
   //                     },

   //                     {
   //                       widget: 'dxButton',
   //                       location: 'after',
   //                       locateInmenu: 'always',
    //                      options:  {
    //                                  icon: 'info',
    //                                  onClick: () => {  
    //                                                    this.helpfaq() 
    //                                                  }
    //                                },
                        
     //                   }

     //               ];


    menuButtonOption = {
                          icon: 'menu',
                          onClick: () => this.isDrawerOpen = !this.isDrawerOpen
                        }

    helpButtonOption = {
                          icon: 'info',
                          onClick: () => this.helpfaq() 
                        }

    

    loginbtnsignoutvisible: boolean = false;

    // Menu Structure
    navigationlogin: menuitem[];
    navigationfullmenu: menuitem[];
    navigationfilter: menuitem[];
    navigationadminmenu: menuitem[];

    // Drawer
    menuopen: boolean             = true;
    isDrawerOpen: boolean         = true;
    isCloseOutsideClick: boolean  = false;
    selectedOpenMode: string      = 'shrink';
    selectedPosition: string      = 'left';
    selectedRevealMode: string    = 'slide';

    // Toast Messages
    toastFileMessage: string = '';
    toastVisible: boolean = false;
    toasttypeerror: string = 'error';
    toastdisplaytime: number = 3000;
    toastwidth: string = '240';
    settoastwidth: string = '240';

    successORFail: number;

    loginstart: string = "";
    loginexist: string = "";
    listvisible: boolean = true;
    listcollapse: boolean = true;
    listnodestatus: string[] = [];

    eventemail:     string = '';
    eventpassword:  string = '';

    popregistereventVisible: boolean = false;

    // FAQ
    popfaq: boolean = false;
    popfaqnote: boolean = false;
    faqtitle: string = '';
    faqitem: number = -1;
    loginfaq: number = -1;
    faqnotetext: string =''
    faqkey  = '[ FAQ1 ]'

    popupactive: boolean = false;
    //**************************************************************
    constructor (  
                  private firestoredata: firestorecontrol, 
                  private routernavigate: Router,
                  private _Activatedroute:ActivatedRoute,
                  private menuselect: liststructures,
                  private dialog: MatDialog,
                  private cdRef : ChangeDetectorRef
                )
      {
        // Inject Menu Structures
        // Menu - GetOrganised

        // Login Menu
        this.navigationlogin = this.menuselect.getmenuLoginList();

        // Full Menu
        this.navigationfullmenu = this.menuselect.getmenuList();

        // Admin Menu
        this.navigationadminmenu = this.menuselect.getmenuListAdmin();

        // Menu - Login and Registration Options Only
        // Default - Option until user registers for event or login successfully
        this.navigationfilter = this.navigationlogin
        this.listnodestatus.push("L")

        this.onGroupClick = this.onGroupClick.bind( this); 

        this.helpfaq = this.helpfaq.bind(this);
        
       
        
         // this.navigationfilter = this.navigation.filter( element => element.statusvisible == 0  )
      }
    //**************************************************************  
    ngOnInit(): void 
      {
        //****************************************************************
        // Determine Display Device Screen Width & Height
        this.windowWidth         = window.innerWidth;
        this.windowHeight        = window.innerHeight - (  this.widowbottomoffset - 0 );
        this.windowHeightFAQ     = this.windowHeight - 100;

        //console.log(  this.windowHeight + ' ' + this.widowbottomoffset )
        //****************************************************************
        // Startup Component
        // Home Page to give an oversite what GetOrganise does
        this.routernavigate.navigate( ['/comphome/' + this.windowHeight], { replaceUrl: true })
        //*****************************************************************
       
      }
    //***************************************************************** 
    ngAfterViewChecked()
      { 
        //----------------------------------------------------------------
        if ( this.loginexist == 'LOGINEXIST' )
          {

            // Create Array Here to 
            const items = this.list.instance.getDataSource().items();

            this.listnodestatus = [] // Create Empty Array

            this.list.instance.beginUpdate();
  
            for ( let i = 0; i <= items.length-1; i++ )
              { 
                switch ( i )
                  {
                    case 0: {
                              this.listnodestatus.push("O")
                              break;
                            }

                    default: {
                              this.listnodestatus.push("C")
                              break;
                            }
                  }
              }

             // console.log( this.listnodestatus)

            this.collapseGroup(1, 6 );
         
            this.list.instance.endUpdate();

            this.loginexist = '';
          }
         //----------------------------------------------------------------
         
        this.cdRef.detectChanges();
      }
    //*******************************************************
    menutargetclick( event: any)
      {  
        // Buttons
        //this.loginbtnvisible = false;
        //**************************************************************
        // Menu Selected
        var menuselect = event.itemData.id;
        var routepath: string;
        //**************************************************************
  
        switch ( menuselect )
          {
            // Login Box
            case 10: 
            case 20:  { 
                        this.registerORLoginBox(  menuselect );
                        break;
                      }
                        
            case 100:  
                      {

                        this.formtitle     = "Event Participants - " + this.selectEventId;

                        routepath    = '/compeventprofile/' + this.selectEventId + '/' + this.windowHeight;
                        this.routernavigate.navigate([ routepath ], { replaceUrl: true });
                        break;
                      } 

            case 200:  
                      {
                   
                        this.formtitle     = "Invitee Profile"

                        routepath    = '/cominviteedetail/' + this.selectEventId + '/' + this.windowHeight;
                        this.routernavigate.navigate([ routepath ], { replaceUrl: true });
                        break;
                      }

            case 210:  
                      {

                        this.formtitle     = "Invitation Delivery Profile"

                        routepath    = '/cominviteeinvite/' + this.selectEventId + '/' + this.windowHeight;
                        this.routernavigate.navigate([ routepath ], { replaceUrl: true });
                        break;
                      }

            case 220:  
                      {

                        this.formtitle     = "Gift Registry Profile"

                        routepath    = '/cominviteegiftregister/' + this.selectEventId + '/' + this.windowHeight;
                        this.routernavigate.navigate([ routepath ], { replaceUrl: true });
                        break;
                      }

            case 230:  
                      {

                        this.formtitle     = "Invitee Coming, Not or Undecided"

                        routepath    = '/cominviteersvp/' + this.selectEventId + '/' + this.windowHeight;
                        this.routernavigate.navigate([ routepath ], { replaceUrl: true });
                        break;
                      }

            case 240:  
                      {

                        this.formtitle     = "Seating Profile"

                        routepath    = '/cominviteeseating/' + this.selectEventId + '/' + this.windowHeight;
                        this.routernavigate.navigate([ routepath ], { replaceUrl: true });
                        break;
                      }

            case 250:  
                      {

                        this.formtitle     = "Gift / Invitee / Thankyou Profile"

                        routepath    = '/cominviteegiftthankyou/' + this.selectEventId + '/' + this.windowHeight;
                        this.routernavigate.navigate([ routepath ], { replaceUrl: true });
                        break;
                      }

            case 300:  
                      {

                        this.formtitle     = "Event Task / Appointment / Collaborators ->  Management "

                        routepath    = '/comtodo/' + this.selectEventId + '/' + this.windowHeight;
                        this.routernavigate.navigate([ routepath ], { replaceUrl: true });
                        break;
                      }

            case 400:  
                      {

                        this.formtitle     = "Event Appointments"

                        routepath    = '/comappointment/' + this.selectEventId + '/' + this.windowHeight;
                        this.routernavigate.navigate([ routepath ], { replaceUrl: true });
                        break;
                      }

            case 450:  
                      {

                        this.formtitle     = "Event Finances"

                        routepath    = '/comfinance/' + this.selectEventId + '/' + this.windowHeight;
                        this.routernavigate.navigate([ routepath ], { replaceUrl: true });
                        break;
                      }
            
            case 500:  
                      {

                        this.formtitle     = "Dashboard - Invitee"

                        routepath    = '/compguestsnapshot/' + this.selectEventId + '/' + this.windowHeight;
                        this.routernavigate.navigate([ routepath ], { replaceUrl: true });
                        break;
                      }

            case 510:  
                      {

                        this.formtitle     = "Dashboard - To Do task"

                        routepath    = '/comtodolistsnapshot/' + this.selectEventId + '/' + this.windowHeight;
                        this.routernavigate.navigate([ routepath ], { replaceUrl: true });
                        break;
                      }

            case 515:  
                      {

                        this.formtitle     = "Dashboard - Appointment(s) Task"

                        routepath    = '/comappointmentsnapshot/' + this.selectEventId + '/' + this.windowHeight;
                        this.routernavigate.navigate([ routepath ], { replaceUrl: true });
                        break;
                      }

            case 520:  
                      {
                        routepath    = '/compfinancesnapshot/' + this.selectEventId + '/' + this.windowHeight;
                        this.routernavigate.navigate([ routepath ], { replaceUrl: true });
                        break;
                      }

            case 1000: {
                          
                         // routepath    = 'propdocadmin/' + this.windowHeight + '/faqadmin/' + this.windowHeight
                          routepath    = 'faqadmin/' + this.windowHeight
                          this.routernavigate.navigate([ routepath ], { replaceUrl: true });
                          break;
                       }
          }
        //**************************************************************
        if ( menuselect >= 100 )
          {
            // Close Drawer when a menuitem is selected
            this.isDrawerOpen = false;
          }
      }
    //**************************************************************
    // Event
    // 01. Stripe Payment and Registration  = 10
    // 02. Login to Event                   = 20
    registerORLoginBox( logintype: number) 
      {
        //**************************************************************
        this.toastdisplaytime = 15000;
        this.toastwidth       = this.settoastwidth ;
        //**************************************************************
        var loginheight: string;
        var loginwidth: string;
        //----------------------------------------------------------------
        switch ( logintype )
          {
            // Registration of Event i.e payment of the event
            case 10:  {
                        loginheight = '300px';
                        loginwidth =  '450px';
                        break;
                      }

            // Login
            case 20:  {
                        loginheight = '180px';
                        loginwidth =  '470px';
                        break;
                      }
          }
        //----------------------------------------------------------------
        //**************************************************************  
        // Register OR Login Dialogue Box
        //**************************************************************
        // Dialog Box Parameters Default Parameters
        const dialogData = new RegistrationLoginModal
                            ( 
                              false,            // closestatus        
                              logintype,        // registerOrLogin
                              '',               // eventid
                              '',               // eventname
                              '',               // selpassword
                              '',               // email
                              false,            // loginstatus 
                              0,                // Error Code
                              '',               // Reset Password
                              false,            // StripeStatus
                              '',               // Stripetoken
                              -1,               // Spare    
                            );
        //**************************************************************
        // Open Login Dialog Form for Registering a Event OR Login to a Event
        const dialogRef = this.dialog.open(  ComloginComponent,  // LogIn Component
                                                {
                                                  height: loginheight,
                                                  width:  loginwidth,

                                                  position: {
                                                                top: '5%',
                                                                left: '10%'
                                                              },
                                                  
                                                  disableClose: true,           // prevent closing by click outside dialog box
                                                  
                                                  closeOnNavigation: false,     // dialog should automatically close itself when we navigate to another route in our single page application,
                                                  data: dialogData              // data being passed to Dialog Box
                                                }
                                              
                                          )
        //**************************************************************
        // Return Data from Login/Registration Form
        // dialogRef = Register / Login Dialogue Form 
        // Close Form
        dialogRef.afterClosed().subscribe(  dialogResult => {
                                                                //console.log( dialogResult )
                                                                
                                                                //**************************************************************
                                                                if ( dialogResult.closestatus )
                                                                  {
                                                                      // Login Details all Successful does not include new registration
                                                                      if ( dialogResult.loginstatus == true ) 
                                                                        {

                                                                         // console.log( 'James')
                                                                          // EventId controls all Routers - Firestore collection tables
                                                                          this.selectEventId = dialogResult.eventid
                                                                        }

                                                                  }
                                                                //**************************************************************
                                                                // Toast Messages
                                                                switch (  dialogResult.registerOrLogin )  
                                                                  {
                                                                    //**************************************************************
                                                                    // Registration
                                                                    case 10:
                                                                        {
                                                                          //**************************************************************
                                                                          switch ( dialogResult.errorcode )
                                                                            {
                                                                              //**************************************************************
                                                                              // Cancel
                                                                              case 0:
                                                                                {
                                                                                  this.displayToast( 'Registration Cancel', 'info', 5000, this.settoastwidth )
                                                                                  break
                                                                                }
                                                                              //**************************************************************  
                                                                              // Register Event
                                                                              case 100:
                                                                                {
                                                                                 
                                                                                  switch ( this.successORFail )
                                                                                    {
                                                                                      // Fail
                                                                                      case 0: {
                                                                                                  this.displayToast( "Register Event Unsuccessful", 'error', 5000, this.settoastwidth )
                                                                                                  break;
                                                                                              }
                                                                                                                                              
                                                                                      // Success
                                                                                      default: {

                                                                                               //   console.log( 'xxxxxxxxxx')
                                                                                               //  console.log( dialogResult.selemail );
                                                                                                //  console.log( dialogResult.selpassword );

                                                                                                  this.eventemail     = dialogResult.selemail;
                                                                                                  this.eventpassword  = dialogResult.selpassword
                                                                                                  this.loginexist     = 'LOGINEXIST';
                                                                                                  
                                                                                                  // Build Popup
                                                                                                  this.popregistereventVisible = true;

                                                                                                  // this.displayToast( "Register Event Successful", 'success', 5000, this.settoastwidth )
                                                                                                  // this.selectEventId    = this.successORFail.toString(); 
                                                                                                 
                                                                                                  //this.navigationfilter = this.navigationfullmenu;
                                                                                                  break;  
                                                                                              }
                                                                                    }
                                                                                    break
                                                                                  }
                                                                              //**************************************************************
                                                                            }
                                                                          //**************************************************************  
                                                                          break; 
                                                                        }
                                                                    //**************************************************************    
                                                                    // Login
                                                                    case 20:
                                                                        {
                                                                          switch ( dialogResult.errorcode )
                                                                            {
                                                                              //--------------------------------------------------------------
                                                                              // Cancel
                                                                              case 0:
                                                                                {
                                                                                  this.displayToast( 'Login cancel', 'info', 5000, this.settoastwidth )
                                                                                  break
                                                                                }
                                                                              //--------------------------------------------------------------
                                                                              // Login Successful - Event Organisers
                                                                              case 100:
                                                                                {
                                                                                  // Close Drawer when a menuitem is selected
                                                                                  //this.isDrawerOpen = false;

                                                                                  this.loginexist = 'LOGINEXIST';
                                                                                  this.navigationfilter = this.navigationfullmenu;
                                                                                
                                                                                  this.displayToast( 'Login Successful', 'success', 5000, this.settoastwidth )

                                                                                
                                                                                  break
                                                                                }  
                                                                              //--------------------------------------------------------------
                                                                              // Login Successful - Administrators 
                                                                              case 110:
                                                                                {
                                                                                  this.loginexist = 'LOGINEXIST';
                                                                                  this.navigationfilter = this.navigationadminmenu;

                                                                                 // console.log( this.navigationfilter )

                                                                                  this.displayToast( 'Administrator Login Successful', 'success', 5000, this.settoastwidth )
                                                                                  break;
                                                                                }
                                                                              //--------------------------------------------------------------
                                                                              // Login - Reset Password Successful
                                                                              case 120:
                                                                                {

                                                                                  this.firestoredata.updateeventpassword  (   
                                                                                                                              this.selectEventId,
                                                                                                                              dialogResult.newpassword                                                           
                                                                                                                          ).then( data => {
                                                                                                                                            this.successORFail = data

                                                                                                                                            switch ( this.successORFail )
                                                                                                                                              {
                                                                                                                                                // Fail
                                                                                                                                                case 0: {
                                                                                                                                                          this.displayToast( "Password Reset Unsuccessful", 'error', 5000, this.settoastwidth )
                                                                                                                                                          break;
                                                                                                                                                        }

                                                                                                                                                // Success
                                                                                                                                                case 1: {
                                                                                                                                                          this.displayToast( "Password Reset Successful", 'success', 5000, this.settoastwidth )
                                                                                                                                                          this.loginexist = 'LOGINEXIST';
                                                                                                                                                          this.navigationfilter = this.navigationfullmenu;
                                                                                                                                                          break;  
                                                                                                                                                        }
                                                                                                                                              }

                                                                                                                                          }
                                                                                                                                  );
                                                                                                                                            
                                                                                                                                     
                                                                                  // Close Drawer when a menuitem is selected
                                                                                  //this.isDrawerOpen = false;
                                                                               
                                                                                  
                                                                                  
                                                                                  break;
                                                                                }    
                                                                              //--------------------------------------------------------------
                                                                              // Login Unsuccessful
                                                                              case 200:
                                                                                {
                                                                                  this.displayToast( 'Login Unsuccessful', 'error', 5000, this.settoastwidth )
                                                                                  break
                                                                                }  
                                                                              //--------------------------------------------------------------
                                                                            }
                                                                        }
                                                                  }
                                                            }
                                          );
       //**************************************************************  
      }
    //**************************************************************
    collapseGroup (startgroupIndex: number, endgroupIndex: number ) 
      {
      
        for ( let i = startgroupIndex; i <= endgroupIndex; i++ )
          { 
            this.list.instance.collapseGroup(i);
          }
        
      }

    //**************************************************************
    displayToast( toastmsg: string, toaststatus: string, toastdisplaysec: number, toastwidth: string )
      {

        this.toastFileMessage = toastmsg;
        this.toasttypeerror   = toaststatus;
        this.toastdisplaytime = toastdisplaysec;
        this.toastwidth       = toastwidth ;
        this.toastVisible     = true;

      }
    //**************************************************************
    onGroupClick( groupkey: string )
      {
        const items = this.list.instance.getDataSource().items();
        const index = items.findIndex(i => i.key === groupkey)
        //console.log( groupkey + ' ' +  index + ' ' + this.listnodestatus[index] )

        // Applies all Nodes except for Registration / Login
        if ( index != 0 )
          {

            if ( this.listnodestatus[index] == "O")   // Node is Open
              {
                this.listnodestatus[index] = "C"
                this.list.instance.collapseGroup( index )
              }
            else
              {
                  
                if ( this.listnodestatus[index] == "C" )
                  {
                    // Node is close
                    //console.log(  this.selectEventId  )

                    this.firestoredata.cnteventparticipants( this.selectEventId  )
                                .then ( ( value ) => {
                                                        const nocnt: number = value;

                                                       // console.log( nocnt )

                                                        if ( nocnt > 0 )
                                                          {
                                                            this.listnodestatus[index] = "O"
                                                            this.list.instance.expandGroup(index); 
                                                          }
                                                        else
                                                          {
                                                            this.displayToast( 'Need to create Event Organisers->Set Profiles', 'error', 5000, '300' )
                                                          }
                                                      

                                                      }

                                      )
                    }

              }

          }
    
      }
    //**************************************************************
    helpfaq()
      {
        //console.log('Faq')

        this.appformname = this.routernavigate.url.toLowerCase();

        var startpos = this.appformname.indexOf('/') + 1;
        var lastpos  = this.appformname.indexOf('/',startpos);
        var nochar   = ( lastpos - startpos ) + 1
        
        this.appformname = this.appformname.slice(startpos,nochar);
        this.appformname = this.appformname.trim();

        console.log( this.appformname  )

        this.loginfaq = -1; // Trigger to PopUp - FAQ screen
        //**************************************************************
        switch ( this.appformname )
          {
            case 'comphome':
              {
                this.faqtitle = 'Register or Login'
                this.loginfaq = 1; 
                break;
              }

            case 'compeventprofile':
                {
                  this.faqtitle = 'Set Organiser Profiles';
                  this.loginfaq = 100; 
                  break;
                }

            case 'cominviteedetail':
              {
                this.faqtitle = 'Invitee Details';
                this.loginfaq = 200; 
                break;
              }

            case 'cominviteeinvite':
              {
                this.faqtitle = 'Invitation Details';
                this.loginfaq = 210; 
                break;
              }

            case 'cominviteegiftregister':
              {
                this.faqtitle = 'Gift Register';
                this.loginfaq = 220; 
                break;
              }

            case 'cominviteersvp':
              {
                this.faqtitle = 'Invitee Undecided, Coming or Not';
                this.loginfaq = 230; 
                break;
              }

            case 'cominviteeseating':
              {
                this.faqtitle = 'Invitee Seating';
                this.loginfaq = 240; 
                break;
              }

            case 'cominviteegiftthankyou':
              {
                this.faqtitle = 'Gift and Thankyou Notes';
                this.loginfaq = 250; 
                break;
              }

            case 'comtodo':
              {
                this.faqtitle = 'Event ToDo Task list';
                this.loginfaq = 300; 
                break;
              }

            case 'comappointment':
              {
                this.faqtitle = 'Event Appointnments';
                this.loginfaq = 400; 
                break;
              }

            case 'comfinance':
              {
                this.faqtitle = 'Event Finances';
                this.loginfaq = 450; 
                break;
              }

            case 'compguestsnapshot':
              {
                this.faqtitle = 'Invitee Snapshot';
                this.loginfaq = 500; 
                break;
              }

            case 'comtodolistsnapshot':
              {
                this.faqtitle = 'ToDo Tasklist Snapshot';
                this.loginfaq = 510; 
                break;
              }

            case 'comappointmentsnapshot':
              {
                this.faqtitle = 'Appointment Snapshot';
                this.loginfaq = 515; 
                break;
              }

              case 'compfinancesnapshot':
                {
                  this.faqtitle = 'Finance Snapshot';
                  this.loginfaq = 520; 
                  break;
                }
  
          }
        //**************************************************************
        // Retrieve FAQ Notes
        if (  this.loginfaq > -1)
          {
            this.faqnotes( this.loginfaq )
          }
        //**************************************************************
      }
    //************************************************************** 
    // faqnotes
    faqnotes( faqid: number )
      {
        this.popupactive = true;

        this.popfaq = true;

        // Locate FAQ list
        this.firestoredata.loadfaqdocument( faqid.toString() );

        // FAQ Details
        this.faqproperty = this.firestoredata.getfaqdocument().subscribe
        ( faqdocitems => 
          { 
            this.faqprofile = faqdocitems; 
          }
        );   

      }
  //************************************************************** 
  accordiontargetclick( event: any)
    {
      var faqopen = this.faqaccordion.selectedIndex;

      //console.log( faqopen )

      if ( faqopen != -1 )
        {
          // Could be eliminated
         // console.log( 'Open');

         // console.log( event.itemData.note )

          this.faqnotetext = event.itemData.note;

         // console.log( this.textAreaElement.nativeElement.clientHeight )
       
        }
    
    }
    //**************************************************************  
    popuphide(event: any)
      {
        this.popupactive = false;
      }
    //**************************************************************
    textareakeypress(event: any)
      {
        //console.log( event )
       // console.log( event.event.originalEvent.code )

        //this.popfaqnote = true;

      }

  }
  //**************************************************************  

